import { Injectable, inject } from '@angular/core';

import { ApContentService } from '@ap/content';
import { FilesValidator, NotificationMetadata, ReadFile, UploadStatus, ApFileSelectorComponent } from '@ap/file';

@Injectable()
export class ApFinishedValidator implements FilesValidator {
    private readonly contentService = inject(ApContentService);

    public fileSelector: ApFileSelectorComponent;

    public showNotification = false;

    public getNotification(): NotificationMetadata {
        return {
            type: 'success',
            content: this.contentService.get('file-upload.finished'),
            testId: 'upload-finished'
        };
    }

    public validate(previousValue: ReadFile[], currentValue: ReadFile[]): boolean {
        const result = currentValue.length > 0 && currentValue.every((file) => file.status === UploadStatus.COMPLETE);
        this.showNotification = result;
        return true;
    }
}
